var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6675 4.4292H28.3325C34.7025 4.4292 38.5 8.22671 38.5 14.5967V29.2617C38.5 35.6317 34.7025 39.4292 28.3325 39.4292H13.6675C7.2975 39.4292 3.5 35.6317 3.5 29.2617V14.5967C3.5 8.22671 7.2975 4.4292 13.6675 4.4292ZM30.5735 19.5483L20.9539 29.0046C20.3125 29.635 19.5002 29.9292 18.6879 29.9292C17.8756 29.9292 17.0205 29.635 16.4219 29.0046L13.2154 25.8525C11.9328 24.6337 11.9328 22.6163 13.2154 21.3975C14.4552 20.1787 16.4647 20.1787 17.7473 21.3975L18.6879 22.3221L26.0416 15.0933C27.2815 13.8745 29.2909 13.8745 30.5735 15.0933C31.8134 16.3121 31.8134 18.3295 30.5735 19.5483Z",
    fill: "#6C84F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoting);
export default __webpack_public_path__ + "static/media/voting.3583a60c6ac116ee5e9bbe812fddeb8a.svg";
export { ForwardRef as ReactComponent };